module.exports = __webpack_public_path__ + "img/volume-plus.239288b3.svg";